import _ from "lodash";

export const calcPaginate = (allState,currentPage,perPage) => {
    const startIndex = (currentPage - 1) * perPage;
    return _(allState).slice(startIndex).take(perPage).value();
}